module.exports = __webpack_public_path__ + "media/images/icons/flags/GU-2b486bdea6bfa2cb7ffe91d0dc152f2c.svg";